<template>
  <div class="contact">
    <ContactHeader />
    <ContactForm />
  </div>
</template>

<script>
import { useMeta } from "vue-meta";
import ContactHeader from "@/components/contact/ContactHeader.vue";
import ContactForm from "@/components/contact/ContactForm.vue";
export default {
  components: {
    ContactHeader,
    ContactForm,
  },
  mounted() {
    import("@/assets/globalJs/global.js").then((module) => {
      const { observeElements } = module;
      observeElements(
        ".slide-right",
        ".slide-left",
        ".fall-down",
        ".image-fade-in"
      );
    });
  },
  setup() {
    useMeta({
      title:
        "Contact Livratos – Plateforme de livraison BTP pour artisans et fournisseurs",
      description: [
        {
          content:
            "Une question sur Livratos, la plateforme de livraison dédiée au BTP ? Contactez notre équipe pour en savoir plus sur nos services pour artisans, fournisseurs et livreurs.",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.livratos.fr/contact",
        },
      ],
    });
  },
};
</script>
